module.exports = __webpack_public_path__ + "img/si.3aa3dafe.svg";